// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"f6448b8a","568":"b681d4cf","791":"991695a3","855":"ab2fe03f","898":"80d88b87","923":"25bde3f1"}[chunkId] + ".chunk.css";
};